module.exports = "/next-static/_next/static/images/hero_image_small-f946080866c32f73b205798cb6777acb.webp";